module.exports = __webpack_public_path__ + "static/logo_nav-188e24b04e83697b02709d57e6e8da0f.png";